<template>
    <div
        :data-component-name="$options.name"
    >
        <div v-if="$apollo.loading" class="-loading">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div v-else-if="!project">Projet introuvable</div>
        <div v-else class="c-project-card">
            <div class="-controls text-right">
                <button
                    v-if="project && myProfile && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')"
                    class="o-button -blue -outline -md"
                    @click.prevent="$eventBus.$emit('jump-to-project', {projectID: project.id, currentDate: project.start_date})"
                >
                    Ouvrir le projet
                    <q-icon name="launch" class="o-ico -right" />
                </button>
                <button class="o-button -blue -outline -md q-ml-md" onclick="window.print();">
                    Imprimer
                    <q-icon name="print" class="o-ico -right" />
                </button>
                <button class="o-button -blue -md q-ml-md"
                    @click.stop="$emit('close-dialog')"
                >
                    Fermer
                    <q-icon name="close" class="o-ico -right" />
                </button>
            </div>
            <div class="-row -project">
                <div class="col -w2/3 -first" style="display: flex; flex-direction: column">

                    <!-- <h3 class="-section">
                        Description générale
                    </h3> -->

                    <div class="-frame flex-grow">
                        <div v-if="project.contract_number!=''" class="q-mb-xs">
                            Contrat #{{ project.contract_number }}
                        </div>
                        <h2 v-if="project.name!=''" class="q-mb-sm">
                            {{ project.name }}
                        </h2>
                        <h3 class="q-mb-sm"
                            :key="cui"
                            v-for="(customers, cui) in project.customers"
                        >
                            {{ customers.name }}
                            <UserProfileInfo :userProfile="customers" />
                        </h3>
                        <!-- <h3 v-if="customerNames!=''" class="q-mb-sm">
                            {{ customerNames }}
                        </h3> -->
                        <div>
                            du {{ date2str(project.start_date).long }}
                            au {{ date2str(project.end_date).long }}
                        </div>
                    </div>

                    <!-- <div v-if="project.description && project.description.trim()!=''" class="q-mt-md">
                        <div class="-label">Description</div>
                        <div class="-value -text" v-html="$nl2br(project.description)"></div>
                    </div> -->
                    

                </div>
                <div class="col">
                    <h3 class="-section" v-if="project.description && project.description.trim() != ''">
                        Description du projet
                    </h3>
                    <div class="-value -text" v-html="$nl2br(project.description)" v-if="project.description && project.description.trim() != ''"></div>
                </div><div></div>


                <div v-if="project.locations.length > 0 || customerLocations.length > 0" class="col q-mt-lg">
                    <h3 class="-section" v-if="(project.locations.length == 1 || customerLocations.length == 1) ">Lieu de rassemblement</h3>
                    <h3 class="-section" v-else>Lieux de rassemblement</h3>
                    <template v-if="customerLocations.length">
                        <div class="q-mb-md" v-for="(customer, ccli) in customerLocations" :key="customer.id+'ccli'+ccli">
                            <div class="-value text-no-wrap">
                                <strong>{{ customer.name }}</strong>
                                <UserProfileInfo :userProfile="customer" class="q-ml-sm" :size="'16px'" />
                            </div>
                            <div class="row" v-if="(customer.street && customer.street != '')
                                || (customer.town && customer.town != '')
                                || (customer.state && customer.state != '')
                                || (customer.country && customer.country != '')
                                || (customer.zipcode && customer.zipcode != '')
                                ">
                                <div class="-col">
                                    <div class="-value -text text-no-wrap" v-if="customer.street && customer.street">
                                        {{ customer.street && customer.street }}
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(customer.town && customer.town != '') || (customer.state && customer.state != '')">
                                        <span v-if="customer.town && customer.town != ''">
                                            {{ customer.town && customer.town }}
                                        </span>
                                        <span v-if="customer.state && customer.state != ''">
                                            {{ customer.state && customer.state }}
                                        </span>
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(customer.zipcode && customer.zipcode != '') || (customer.country && customer.country != '')">
                                        <span class="q-mr-sm" v-if="customer.zipcode && customer.zipcode != ''">
                                            {{ customer.zipcode && customer.zipcode }}
                                        </span>
                                        <span v-if="customer.country && customer.country != ''">
                                            {{ customer.country && customer.country }}
                                        </span>
                                    </div>
                                </div>
                    
                            </div>
                        </div>
                    </template>
                    <template v-if="project.locations.length">
                        <div class="q-mb-md" :key="ci" v-for="(location, ci) in project.locations">
                    
                            <div class="-value text-no-wrap">
                                <strong>{{ location.name }}</strong>
                                <UserProfileInfo :userProfile="location" class="q-ml-sm" :size="'16px'" />
                            </div>
                            <div class="row" v-if="(location.street && location.street != '')
                                || (location.town && location.town != '')
                                || (location.state && location.state != '')
                                || (location.country && location.country != '')
                                || (location.zipcode && location.zipcode != '')
                                ">
                                <div class="-col">
                                    <div class="-value -text text-no-wrap" v-if="location.street && location.street">
                                        {{ location.street && location.street }}
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(location.town && location.town != '') || (location.state && location.state != '')">
                                        <span v-if="location.town && location.town != ''">
                                            {{ location.town && location.town }}
                                        </span>
                                        <span v-if="location.state && location.state != ''">
                                            {{ location.state && location.state }}
                                        </span>
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(location.zipcode && location.zipcode != '') || (location.country && location.country != '')">
                                        <span class="q-mr-sm" v-if="location.zipcode && location.zipcode != ''">
                                            {{ location.zipcode && location.zipcode }}
                                        </span>
                                        <span v-if="location.country && location.country != ''">
                                            {{ location.country && location.country }}
                                        </span>
                                    </div>
                                </div>
                    
                            </div>
                        </div>
                    </template>
                </div>

                <div class="col q-mt-lg" v-if="project.projectManager || project.supervisor || project.contacts.length > 0">
                    
                    <h3 class="-section">
                        Responsables
                    </h3>

                    <div v-if="project.projectManager" class="q-mb-md">
                        <div class="-label">Chargé de projet</div>
                        <div class="-value">
                            {{ project.projectManager.name }}
                            <UserProfileInfo :userProfile="project.projectManager" />
                        </div>
                    </div>

                    <div v-if="project.supervisor" class="q-mb-md">
                        <div class="-label">Superviseur des travaux</div>
                        <div class="-value">
                            {{ project.supervisor.name }}
                            <UserProfileInfo :userProfile="project.supervisor" />
                        </div>
                    </div>

                    <div v-if="project.contacts.length>0" class="q-mb-md">
                        <div class="-label" v-if="project.contacts.length==1">Contact client</div>
                        <div class="-label" v-else>Contacts client</div>
                        <div class="-value" :key="ci" v-for="(contact, ci) in project.contacts">
                            {{ contact.name }}
                            <UserProfileInfo :userProfile="contact" />
                            <div class="q-mr-xs q-mt-xs" style="font-weight: 300; line-height: 1.3;" v-if="$generalSettings.settings.showContactPhoneOnProjectCard==true && contact.primary_phone && contact.primary_phone.trim() != ''">
                                <q-icon name="phone" class="q-mr-xs" />
                                <a :href="'tel:' + contact.primary_phone">{{ contact.primary_phone }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col q-mt-lg"
                    v-if="customtags.length">

                    <h3 class="-section" v-if="customtags.length">
                        Informations supplémentaires
                    </h3>


                    <div v-if="customtags.length>0" class="">
                        <div :key="ci" v-for="(customtag, ci) in customtags">
                            <div class="-label q-mt-md"
                                v-if="ci==0 
                                || ( ci>0 && customtag.label.id!= customtags[ci-1].label.id )"
                            >
                                {{ customtag.label.name }}</div>
                            <div class="-value">{{ customtag.name }}</div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="-row -project-shifts -project-shifts__wrap" v-if="selectedProjectShifts && selectedProjectShifts.length>0">
                <div class="col">
                    <h3 class="-section">
                        Quart de travail sélectionné
                    </h3>
                </div>
                <div class="col -w2/3 -hidden-mobile">
                    <h3 class="-section">
                        Affectations
                    </h3>
                </div>
                <div class="-row -project-shifts -alternate"
                    :key="psi"
                    v-for="(projectShift, psi) in selectedProjectShifts"
                >
                    <div class="col">
                        <div class="-frame q-mb-md">
                            <h2 v-if="projectShift.name!=''" class="q-mb-sm">
                                {{ projectShift.name }}
                            </h2>
                            <span
                                :key="di"
                                v-for="(date, di) in projectShift.dates"
                            >
                                <span v-if="di>0">, </span>
                                <span v-if="date.from!=date.to">du {{ date2str(date.from).long }}
                                    au {{ date2str(date.to).long }}</span>
                                <span v-else>le {{ date2str(date.from).long }}</span>
                            </span>
                        </div>

                        <div class="q-mb-md" v-if="projectShift.supervisor">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Superviseur des travaux
                            </div>
                            <div class="-value row items-center" style="position: relative;">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ projectShift.supervisor.name }}
                                <UserProfileInfo :userProfile="projectShift.supervisor" class="q-ml-sm" />
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="q-mb-md" v-if="projectShift.customerContact">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Contact client
                            </div>
                            <div class="-value row items-center" style="position: relative;">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ projectShift.customerContact.name }}
                                <UserProfileInfo :userProfile="projectShift.customerContact" class="q-ml-sm" />
                            </div>
                            <!-- </div> -->
                        </div>

                        <div v-if="projectShift.description && projectShift.description.trim()!=''" class="q-mb-md">
                            <div class="-label">Description</div>
                            <div class="-value" v-html="$nl2br(projectShift.description)"></div>
                        </div>

                        <div v-if="projectShift.start_time" class="q-mb-md">
                            <div class="-label">Heures</div>
                            <div class="-value">
                                de {{ projectShift.start_time }} à {{ projectShift.end_time }}
                            </div>
                        </div>

                        <div v-if="projectShift.start_time" class="q-mb-md">
                            <div class="-label">Jours de la semaine</div>
                            <div class="-value">
                                {{ daysOfWeekStrLong(projectShift) }}
                            </div>
                        </div>

                        <div class="q-mb-md" v-if="$generalSettings.settings.enableAccommodationModule && projectShift.accommodations && projectShift.accommodations.length>0">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Hébergement
                            </div>
                            <div class="-value row items-center" style="position: relative;" :key="ai" v-for="(accommodation, ai) in projectShift.accommodations">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ accommodation.name }}
                                <UserProfileInfo :userProfile="accommodation" class="q-ml-sm" />
                                <div class="row full-width" v-if="(accommodation.street && accommodation.street != '')
                                || (accommodation.town && accommodation.town != '')
                                || (accommodation.state && accommodation.state != '')
                                || (accommodation.country && accommodation.country != '')
                                || (accommodation.zipcode && accommodation.zipcode != '')
                                ">
                                    <div class="-col">
                                        <div class="-value -text text-no-wrap" v-if="accommodation.street && accommodation.street">
                                            {{ accommodation.street && accommodation.street }}
                                        </div>
                                        <div class="-value -text text-no-wrap"
                                            v-if="(accommodation.town && accommodation.town != '') || (accommodation.state && accommodation.state != '')">
                                            <span v-if="accommodation.town && accommodation.town != ''">
                                                {{ accommodation.town && accommodation.town }}
                                            </span>
                                            <span v-if="accommodation.state && accommodation.state != ''">
                                                {{ accommodation.state && accommodation.state }}
                                            </span>
                                        </div>
                                        <div class="-value -text text-no-wrap"
                                            v-if="(accommodation.zipcode && accommodation.zipcode != '') || (accommodation.country && accommodation.country != '')">
                                            <span class="q-mr-sm" v-if="accommodation.zipcode && accommodation.zipcode != ''">
                                                {{ accommodation.zipcode && accommodation.zipcode }}
                                            </span>
                                            <span v-if="accommodation.country && accommodation.country != ''">
                                                {{ accommodation.country && accommodation.country }}
                                            </span>
                                        </div>
                                    </div>
                    
                                </div>

                            </div>
                            <!-- </div> -->
                        </div>

                        <div v-if="projectShift.customtags.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(customtag, ci) in projectShift.customtags">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && customtag.label.id!= projectShift.customtags[ci-1].label.id )"
                                >
                                    {{ customtag.label.name }}</div>
                                <div class="-value">{{ customtag.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.courses.length>0" class="q-mb-md">
                            <div class="-label q-mt-md" v-if="projectShift.courses.length>1">
                                Formations
                            </div>
                            <div class="-label q-mt-md" v-else>
                                Formation
                            </div>
                            <div :key="ci" v-for="(course, ci) in projectShift.courses">
                                <div class="-value">{{ course.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.skills.length>0" class="q-mb-md">
                            <div class="-label q-mt-md" v-if="projectShift.skills.length>1">
                                Compétences
                            </div>
                            <div class="-label q-mt-md" v-else>
                                Compétence
                            </div>
                            <div :key="ci" v-for="(skill, ci) in projectShift.skills">
                                <div class="-value">{{ skill.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.resources.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(resource, ci) in projectShift.resources">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && resource.type.id!= projectShift.resources[ci-1].type.id )"
                                >
                                    {{ resource.type.name }}</div>
                                <div class="-value">{{ resource.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.staffVehicules.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(staffVehicule, ci) in projectShift.staffVehicules">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && staffVehicule.type.id!= projectShift.staffVehicules[ci-1].type.id )"
                                >
                                    {{ staffVehicule.type.name }}</div>
                                <div class="-value">{{ staffVehicule.name }} <small>({{staffVehicule.userProfile.name}})</small></div>
                            </div>
                        </div>

                    </div>
                    <div class="col -w2/3 no-gutters">
                        <div class="-row">
                            <div class="col -w1/2"
                                :key="ai"
                                v-for="(assignment, ai) in projectShift.projectAssignments"
                            >
                                <div class="-label q-mt-md">
                                    {{ assignment.profession.name }}
                                </div>
                                <div class="-value -unassigned" v-if="!assignment.assignedTo">
                                    Non assigné
                                </div>
                                <div class="-value red" v-else>
                                    <q-icon name="star" v-if="assignment.profession.isForeman" color="yellow" style="position:absolute; left: -16px;" />
                                    {{ assignment.assignedTo.name }}
                                    <UserProfileInfo :userProfile="assignment.assignedTo" />
                                </div>
                                <div class="-value -room-number" v-if="$generalSettings.settings.enableAccommodationModule && projectShift.accommodations && projectShift.accommodations.length > 0 && !assignment.accommodation_not_required && assignment.accommodation_room_number">
                                    <UserProfileInfo :userProfile="projectShift.accommodations[0]" :customContent="'Chambre #'+assignment.accommodation_room_number" />
                                </div>
                            </div>
                            <div class="col -w1/2 q-ml-auto -controls"
                                v-if="project && myProfile && (myProfile.role == 'ADMINISTRATOR' || myProfile.role == 'MANAGER' || myProfile.role == 'FOREMAN')"
                            >
                                <div class="-label q-mt-md row items-start" v-html="'&nbsp;'">
                                </div>
                                <div class="-value red row items-center">
                                    <button class="o-button -grey -outline -md q-pt-xs"
                                        @click.stop="mailTO(projectShift)"
                                    >
                                        <q-icon name="mail" size="12px" class="" />
                                        Envoyer un courriel à l'équipe
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="-row -project-shifts -project-shifts__wrap" v-if="projectShifts && projectShifts.length>0">
                <div class="col">
                    <h3 class="-section" v-if="selectedProjectShifts && selectedProjectShifts.length > 0">
                        Autres quarts de travail
                    </h3>
                    <h3 class="-section" v-else>
                        Quarts de travail
                    </h3>
                </div>
                <div class="col -w2/3 -hidden-mobile">
                    <h3 class="-section">
                        Affectations
                    </h3>
                </div>
                <div class="-row -project-shifts -alternate"
                    :key="projectShift.id"
                    v-for="(projectShift) in projectShifts"
                >
                    <div class="col">
                        <div class="-frame q-mb-md">
                            <h2 v-if="projectShift.name!=''" class="q-mb-sm">
                                {{ projectShift.name }}
                            </h2>
                            <span
                                :key="di"
                                v-for="(date, di) in projectShift.dates"
                            >
                                <span v-if="di>0">, </span>
                                <span v-if="date.from!=date.to">du {{ date2str(date.from).long }}
                                    au {{ date2str(date.to).long }}</span>
                                <span v-else>le {{ date2str(date.from).long }}</span>
                            </span>
                        </div>

                        <div class="q-mb-md" v-if="projectShift.supervisor">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Superviseur des travaux
                            </div>
                            <div class="-value row items-center" style="position: relative;">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ projectShift.supervisor.name }}
                                <UserProfileInfo :userProfile="projectShift.supervisor" class="q-ml-sm" />
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="q-mb-md" v-if="projectShift.customerContact">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Contact client
                            </div>
                            <div class="-value row items-center" style="position: relative;">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ projectShift.customerContact.name }}
                                <UserProfileInfo :userProfile="projectShift.customerContact" class="q-ml-sm" />
                            </div>
                            <!-- </div> -->
                        </div>


                        <div v-if="projectShift.description && projectShift.description.trim()!=''" class="q-mb-md">
                            <div class="-label">Description</div>
                            <div class="-value" v-html="$nl2br(projectShift.description)"></div>
                        </div>

                        <div v-if="projectShift.start_time" class="q-mb-md">
                            <div class="-label">Heures</div>
                            <div class="-value">
                                de {{ projectShift.start_time }} à {{ projectShift.end_time }}
                            </div>
                        </div>

                        <div v-if="projectShift.start_time" class="q-mb-md">
                            <div class="-label">Jours de la semaine</div>
                            <div class="-value">
                                {{ daysOfWeekStrLong(projectShift) }}
                            </div>
                        </div>

                        <div class="q-mb-md" v-if="$generalSettings.settings.enableAccommodationModule && projectShift.accommodations && projectShift.accommodations.length>0">
                            <!-- <div style="display:flex; flex-direction: column; padding: 0 15px;"> -->
                            <div class="-label">
                                Hébergement
                            </div>
                            <div class="-value row items-center" style="position: relative;" :key="ai" v-for="(accommodation, ai) in projectShift.accommodations">
                                <!-- <q-icon name="construction" color="light-blue" style="position:absolute; left: -16px;" /> -->
                                {{ accommodation.name }}
                                <UserProfileInfo :userProfile="accommodation" class="q-ml-sm" />
                                <div class="row full-width" v-if="(accommodation.street && accommodation.street != '')
                                || (accommodation.town && accommodation.town != '')
                                || (accommodation.state && accommodation.state != '')
                                || (accommodation.country && accommodation.country != '')
                                || (accommodation.zipcode && accommodation.zipcode != '')
                                ">
                                <div class="-col">
                                    <div class="-value -text text-no-wrap" v-if="accommodation.street && accommodation.street">
                                        {{ accommodation.street && accommodation.street }}
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(accommodation.town && accommodation.town != '') || (accommodation.state && accommodation.state != '')">
                                        <span v-if="accommodation.town && accommodation.town != ''">
                                            {{ accommodation.town && accommodation.town }}
                                        </span>
                                        <span v-if="accommodation.state && accommodation.state != ''">
                                            {{ accommodation.state && accommodation.state }}
                                        </span>
                                    </div>
                                    <div class="-value -text text-no-wrap"
                                        v-if="(accommodation.zipcode && accommodation.zipcode != '') || (accommodation.country && accommodation.country != '')">
                                        <span class="q-mr-sm" v-if="accommodation.zipcode && accommodation.zipcode != ''">
                                            {{ accommodation.zipcode && accommodation.zipcode }}
                                        </span>
                                        <span v-if="accommodation.country && accommodation.country != ''">
                                            {{ accommodation.country && accommodation.country }}
                                        </span>
                                    </div>
                                </div>
                    
                            </div>

                            </div>
                            <!-- </div> -->
                        </div>

                        <div v-if="projectShift.customtags.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(customtag, ci) in projectShift.customtags">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && customtag.label.id!= projectShift.customtags[ci-1].label.id )"
                                >
                                    {{ customtag.label.name }}</div>
                                <div class="-value">{{ customtag.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.courses.length>0" class="q-mb-md">
                            <div class="-label q-mt-md" v-if="projectShift.courses.length>1">
                                Formations
                            </div>
                            <div class="-label q-mt-md" v-else>
                                Formation
                            </div>
                            <div :key="ci" v-for="(course, ci) in projectShift.courses">
                                <div class="-value">{{ course.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.skills.length>0" class="q-mb-md">
                            <div class="-label q-mt-md" v-if="projectShift.skills.length>1">
                                Compétences
                            </div>
                            <div class="-label q-mt-md" v-else>
                                Compétence
                            </div>
                            <div :key="ci" v-for="(skill, ci) in projectShift.skills">
                                <div class="-value">{{ skill.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.resources.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(resource, ci) in projectShift.resources">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && resource.type.id!= projectShift.resources[ci-1].type.id )"
                                >
                                    {{ resource.type.name }}</div>
                                <div class="-value">{{ resource.name }}</div>
                            </div>
                        </div>

                        <div v-if="projectShift.staffVehicules.length>0" class="q-mb-md">
                            <div :key="ci" v-for="(staffVehicule, ci) in projectShift.staffVehicules">
                                <div class="-label q-mt-md"
                                    v-if="ci==0 
                                    || ( ci>0 && staffVehicule.type.id!= projectShift.staffVehicules[ci-1].type.id )"
                                >
                                    {{ staffVehicule.type.name }}</div>
                                <div class="-value">{{ staffVehicule.name }} <small>({{staffVehicule.userProfile.name}})</small></div>
                            </div>
                        </div>

                    </div>
                    <div class="col -w2/3 no-gutters">
                        <div class="-row">



                            <!-- <div class="col -w1/2 q-mt-md" v-if="projectShift.supervisor"></div> -->
                            <div class="col -w1/2"
                                :key="ai"
                                v-for="(assignment, ai) in projectShift.projectAssignments"
                            >
                                <div class="-label q-mt-md row items-start">
                                    {{ assignment.profession.name }}
                                </div>
                                <div class="-value -unassigned" v-if="!assignment.assignedTo">
                                    Non assigné
                                </div>
                                <div class="-value red row items-center" v-else style="position: relative">
                                    <q-icon name="star" v-if="assignment.profession.isForeman" color="yellow" style="position:absolute; left: -16px;"/>
                                    {{ assignment.assignedTo.name }}
                                    <UserProfileInfo :userProfile="assignment.assignedTo" class="q-ml-sm"/>
                                </div>
                                <div class="-value -room-number" v-if="$generalSettings.settings.enableAccommodationModule && projectShift.accommodations && projectShift.accommodations.length > 0 && !assignment.accommodation_not_required && assignment.accommodation_room_number">
                                    <UserProfileInfo :userProfile="projectShift.accommodations[0]" :customContent="'Chambre #'+assignment.accommodation_room_number" />
                                </div>
                            </div>
                            <div class="col -w1/2 q-ml-auto"
                                v-if="project && myProfile && (myProfile.role == 'ADMINISTRATOR' || myProfile.role == 'MANAGER' || myProfile.role == 'FOREMAN')"
                            >
                                <div class="-label q-mt-md row items-start" v-html="'&nbsp;'">
                                </div>
                                <div class="-value red row items-center">
                                    <button class="o-button -grey -outline -md q-pt-xs"
                                        @click.stop="mailTO(projectShift)"
                                    >
                                        <q-icon name="mail" size="12px" class="" />
                                        Envoyer un courriel à l'équipe
                                    </button>
                                </div>
                            </div>


                        </div>
                            <!-- <q-btn
                                dense
                                outline
                                color="grey"
                                rounded
                                size="xs"
                                icon="mail"
                                title="Envoyer un courriel à l'équipe"
                                v-if="project && myProfile && (myProfile.role == 'ADMINISTRATOR' || myProfile.role == 'MANAGER' || myProfile.role == 'FOREMAN')"
                            /> -->
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { PROJECTCARD } from '@/graphql/project/queries'
    import {date2str} from "@/js/dateUtilities"
    import orderBy from "lodash/orderBy";
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'ProjectCard',
        //components: { Component1, Component2 },
        props: {
        	projectID:{
        		type: [Number, String],
        		default: null,
        	},
        	showCard:{
        		type: Boolean,
        		default: true,
        	},
            myAssignments: {
                type: Boolean,
                default: false
            },
            projectShiftID: {
                type: [Number, String],
                default: null
            },
        },
        data(){
        	return {
                skipQueriesStart: true
        	}
        },
        mounted(){
            if(this.showCard) this.skipQueriesStart=false
        },
        computed: {

            customerLocations() {
                return this.project.customers.filter((i) => i.use_contact_as_location)
            },

            selectedProjectShifts(){
                if (!this.projectShiftID) return null;
                return this.project.projectShifts.filter(item => item.id == this.projectShiftID);
            },

            projectShifts(){
                if (!this.projectShiftID) return this.project.projectShifts;


                return this.project.projectShifts.filter(item => item.id != this.projectShiftID);
            },
            
            customtags() {
                if(!this.project.customtags) return [];
                let customtags=orderBy(this.project.customtags, [item => item.label.name.toLowerCase()])
                return customtags;
            }
        },
        watch: {
            showCard() {
                if(this.showCard) this.skipQueriesStart=false
            }
        },
        methods: {
            // getAccommodationContent(assignment) {
            //     return '<i data-v-e846f466="" aria-hidden="true" role="presentation" class="cursor-pointer q-ml-sm material-icons q-icon notranslate text-ciconcolor" data-component-name="UserProfileInfo" style="color: black;">hotel</i> '+assignment.accommodation_room_number;
            // },
        
            daysOfWeekStr(projectShift) {
                let days = new Array();
                if (projectShift.Sun) days.push("Di");
                if (projectShift.Mon) days.push("Lu");
                if (projectShift.Tue) days.push("Ma");
                if (projectShift.Wed) days.push("Me");
                if (projectShift.Thu) days.push("Je");
                if (projectShift.Fri) days.push("Ve");
                if (projectShift.Sat) days.push("Sa");

                return days.join(', ');
            },
            daysOfWeekStrLong(projectShift) {
                let days = new Array();
                if (projectShift.Sun) days.push("dimanche");
                if (projectShift.Mon) days.push("lundi");
                if (projectShift.Tue) days.push("mardi");
                if (projectShift.Wed) days.push("mercredi");
                if (projectShift.Thu) days.push("jeudi");
                if (projectShift.Fri) days.push("vendredi");
                if (projectShift.Sat) days.push("samedi");

                return days.join(', ');
            },

            mailTO(projectShift) {

                let recipients = [];
                projectShift.projectAssignments.forEach(function (assignment) {
                    if (assignment.assignedTo && assignment.assignedTo.email) {
                        recipients.push(assignment.assignedTo.name + ' <' + assignment.assignedTo.email + '>');
                    }
                })

                if (projectShift.supervisor) {
                    recipients.push(projectShift.supervisor.name + ' <' + projectShift.supervisor.email + '>');
                }

                recipients = recipients.join(', ');
                let description = projectShift.description && projectShift.description != '' ? ' %0D%0ADescription: ' + projectShift.description : '';
                let title = this.myProfile && this.myProfile.title && this.myProfile.title != '' ? ' %0D%0A' + this.myProfile.title : '';
                let me = this.myProfile && this.myProfile.name && this.myProfile.name != '' ? ' %0D%0A' + this.myProfile.name : '';
                let dates = [];
                if (projectShift.dates) {
                    projectShift.dates.forEach(function (date) {
                        if (date.from && date.to) {
                            dates.push('du ' + date.from + ' au ' + date.to);
                        } else {
                            dates.push(date);
                        }
                    })
                }
                dates = dates.join(', ');
                window.location.href = "mailto:" + recipients + "?subject=" + this.project.name + " - quart de travail " + projectShift.name.toLowerCase() + "&body=Bonjour, %0D%0A%0D%0AVoici les informations concernant le quart de travail : %0D%0A%0D%0AProjet : " + this.project.name + "%0D%0ANom : " + projectShift.name + description + "%0D%0AHeure de début : " + projectShift.start_time + "%0D%0AHeure de fin : " + projectShift.end_time + "%0D%0AJours de la semaine : " + this.daysOfWeekStr(projectShift) + "%0D%0ADates : " + dates + "%0D%0A%0D%0AMerci, %0D%0A" + me + title;
            },

            date2str(date){
                return date2str(date);
            }
        },
        apollo: {
            project: {
                query: PROJECTCARD,
                fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                skip(){
                    return this.skipQueriesStart
                },
                //debounce: 200,
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables(){
                    let variables={
                        id: this.projectID,
                        myAssignments: this.myAssignments
                    }
                    // if(this.projectShiftID) variables.projectShiftID = this.projectShiftID
                    return {
                        ...variables
                    }
                },
                update(project) {
                    project.project.projectShifts.forEach((projectShift) => {
                        projectShift.projectAssignments.sort((a, b) => {
                            if (a.profession.name < b.profession.name) return -1;
                            if (a.profession.name > b.profession.name) return 1;
                            if (a.profession.name == b.profession.name) {
                                if (!a.assignedTo || !b.assignedTo) return 0;
                                if (a.assignedTo.name < b.assignedTo.name) return -1;
                                if (a.assignedTo.name > b.assignedTo.name) return 1;
                            }
                            return 0;
                        });
                    })
                    return project.project
                },
            },
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        }
    }
</script>